var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebsitewhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1489_54569)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.225586 1.5V21C0.225586 21.83 0.895586 22.5 1.72559 22.5H22.7256C23.5556 22.5 24.2256 21.83 24.2256 21V1.5H0.225586ZM22.7256 5.19H6.05892V3H22.7256V5.19ZM4.55892 3V5.19H1.72559V3H4.55892ZM1.72559 21V6.69H22.7256V21H1.72559Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4556 10.25H12.1756V11.75H21.4556V10.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1323 13.3033H12.1689V14.8033H18.1323V13.3033Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.80892 9.83333H3.97559C3.56225 9.83333 3.22559 10.17 3.22559 10.5833V16.4167C3.22559 16.83 3.56225 17.1667 3.97559 17.1667H9.80892C10.2223 17.1667 10.5589 16.83 10.5589 16.4167V10.5833C10.5589 10.17 10.2223 9.83333 9.80892 9.83333ZM9.05892 15.6667H4.72559V11.3333H9.05892V15.6667Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1489_54569"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.225586)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsitewhite);
export default __webpack_public_path__ + "static/media/websitewhite.3eda47f550c8ceab4732efc6fd29186f.svg";
export { ForwardRef as ReactComponent };